'use strict';
import { Howl } from 'howler';

class BGMController extends Howl {
  constructor(path, html5) {
    super({
      src: [path],
      preload: true,
      html5: html5,
      sprite: {
        proc_field02: [0, 16065.306122448981],
      },
    });

    this.spriteKeys = ['proc_field02'];
  }

  hasKey(key) {
    return this.spriteKeys.includes(key);
  }
}

export default BGMController;
